import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTickCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.0013 18.9583C5.05964 18.9583 1.04297 14.9416 1.04297 9.99996C1.04297 5.05829 5.05964 1.04163 10.0013 1.04163C14.943 1.04163 18.9596 5.05829 18.9596 9.99996C18.9596 14.9416 14.943 18.9583 10.0013 18.9583ZM10.0013 2.29163C5.7513 2.29163 2.29297 5.74996 2.29297 9.99996C2.29297 14.25 5.7513 17.7083 10.0013 17.7083C14.2513 17.7083 17.7096 14.25 17.7096 9.99996C17.7096 5.74996 14.2513 2.29163 10.0013 2.29163Z",
		fill: "#009155"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.81719 12.9833C8.65052 12.9833 8.49219 12.9166 8.37552 12.8L6.01719 10.4416C5.77552 10.2 5.77552 9.79996 6.01719 9.55829C6.25885 9.31663 6.65885 9.31663 6.90052 9.55829L8.81719 11.475L13.1005 7.19163C13.3422 6.94996 13.7422 6.94996 13.9839 7.19163C14.2255 7.43329 14.2255 7.83329 13.9839 8.07496L9.25885 12.8C9.14219 12.9166 8.98385 12.9833 8.81719 12.9833Z",
		fill: "#009155"
	})]
});
export default SvgTickCircle;
